











































































































import { Component, Vue } from 'vue-property-decorator';
import DateFormat from "date-fns/format";
import DateSub from "date-fns/subDays";
import {
    VehicleFilter,
    HistoricalVehicleLog,
    HistoricalDealershipLog,
    VehicleStateType,
    getVehicleStateLabel, SearchDomain
} from "../../types";
import {
    addSearchDomain,
    createVehicleHistoryLog, deleteDomain, getSearchDomains,
    getVehicleHistoryLogs,
    searchByArea,
    searchByAutoGroup,
    searchByDealership, searchByDomainName
} from "../../endpoints";
import {buildDealershipLink, buildVehicleLink} from "../../path";
import {serializeForm} from "../../util";
import Search from "../utility/Search.vue";
import {CloudFunctions} from "@/environment";

//Vue.component("v-search", Search);
//Vue.component("v-search", Search);

@Component
export default class Domains extends Vue {

    SearchByDomainName = searchByDomainName;

    availableDomains: SearchDomain[] = [];

    currentDomainBeingEdited: SearchDomain | null = null;
    currentDomainBeingDeleted: SearchDomain | null = null;

    submitted: boolean = false;
    loadingDomains: boolean = false;

    addDomainForm = {
        domainName: "",
        vehicleContainerClass: "",
        navigationNextClass: "",
        navigationMoreClass: ""
    };

    mounted() {
        this.refreshDomainList();
    }

    async refreshDomainList(id?: number) {

        this.loadingDomains = true;

        const params = new URLSearchParams();

        if(id) {
            params.append("id", `${id}`);
        }

        this.availableDomains = await getSearchDomains(params.toString());

        this.loadingDomains = false;
    }

    onDomainSearchResultSelected(result) {
        this.refreshDomainList(result ? result.id : null);
    }

    onEditDomainButtonClick(domain: SearchDomain) {
        this.currentDomainBeingEdited = domain;

        this.addDomainForm.vehicleContainerClass = domain.vehicle_class;
        this.addDomainForm.domainName = domain.host;
        this.addDomainForm.navigationNextClass = domain.navigation_class_next;
        this.addDomainForm.navigationMoreClass = domain.navigation_class_more;

        (this.$refs['add-domain-modal'] as any).show();
    }

    onDeleteDomainButtonClick(domain: SearchDomain) {
        this.currentDomainBeingDeleted = domain;
        (this.$refs['delete-domain-modal'] as any).show();
    }

    onAddDomainModalHidden() {

        if(this.currentDomainBeingEdited) {
            this.currentDomainBeingEdited = null;
        }

        this.addDomainForm.vehicleContainerClass = "";
        this.addDomainForm.domainName = "";
        this.addDomainForm.navigationNextClass = "";
        this.addDomainForm.navigationMoreClass = "";
    }

    async onAddDomainSubmitButtonClick() {

        if(!this.isValidDomainName || !this.isValidVehicleContainerClass) {
            return;
        }

        this.submitted = true;

        try {
            await addSearchDomain(JSON.stringify(serializeForm(this.$refs['add-domain-form'] as HTMLFormElement)));

            (this.$refs['add-domain-modal'] as any).hide();

            this.refreshDomainList();
        } catch (e) {
            console.error(e);
        } finally {
            this.submitted = false;
        }
    }

    async onConfirmDomainDelete() {

        this.submitted = true;

        try {
            await deleteDomain(this.currentDomainBeingDeleted.id);

            this.refreshDomainList();

            (this.$refs['delete-domain-modal'] as any).hide();
        } catch (e) {
            console.error(e);
        } finally {
            this.submitted = false;
        }
    }

    get isValidVehicleContainerClass() {
        return this.addDomainForm.vehicleContainerClass.length > 0
    }

    get isValidDomainName() {
        return this.addDomainForm.domainName.match(/\S+\.\S+/) !== null;
    }

}
